import { call, select } from 'redux-saga/effects';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { backendClient } from '../../../services/api/backend-client';
import { getLogs, clearLogs } from '../../../utils/logBuffer';
import bugsnagClient from '../../../services/bugsnag/bugsnag';

export function* sendLogsSaga() {
    const { uid } = yield select(selectUserCredentials);
    const logs = getLogs();

    try {
        yield call(
            [backendClient, backendClient.post],
            '/logs',
            { uid, logs }
        );
        // clearLogs();
        // yield call(clearPersistedLogs);
        console.debug('Logs sent successfully, buffer cleared');
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to send logs:', err);
    }
}
